<ng-container
    *ngIf="
        router.url !== '/auth/signin' && router.url !== '/auth/reset'&& !router.url.includes('/auth/resetPassword');
        else blank
    "
>
    <ng-container *ngIf="router.url == '/home'; else navHeader">
        <div class="coverImage">
            <img src="assets/icons/Logomini.png" class="heading-img" alt="" />
        </div>
    </ng-container>
    <ng-template #navHeader>
        <div class="navHeaderSimulator">
            <div class="navHeaderContainer">
                <button (click)="back()" mat-button class="back-controller">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="#142065" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <h2 class="heading2">{{ _pageName | translate }}</h2>
                <img
                    style="width: 108px;"
                    id="navImage"
                    src="assets/icons/Logomini.png"
                    alt=""
                />
            </div>
        </div>
    </ng-template>
</ng-container>
<ng-template #blank></ng-template>
